import Vue from 'vue'
import Router from 'vue-router'
import indexPage from '@/view/index'
import helpPage from '@/view/help'
import servicePage from '@/view/service'
import aboutUsPage from '@/view/aboutUs'
import detailPage from '@/view/detail'
Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/service',
      name: 'servicePage',
      component: servicePage,
    },
    {
      path: '/help',
      name: 'helpPage',
      component: helpPage,
    },
    {
      path: '/aboutUs',
      name: 'aboutUsPage',
      component:aboutUsPage
    },
    {
      path: '/detail',
      name: 'detailPage',
      component:detailPage
    },
    {
      path: '/',
      name: 'indexPage',
      component: indexPage
    },
    {
      path: '*',
      redirect:'/'
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js